import { render, staticRenderFns } from "./TerminalCursorTabWrapper.vue?vue&type=template&id=b037d19c&"
import script from "./TerminalCursorTabWrapper.vue?vue&type=script&lang=js&"
export * from "./TerminalCursorTabWrapper.vue?vue&type=script&lang=js&"
import style0 from "./TerminalCursorTabWrapper.vue?vue&type=style&index=0&id=b037d19c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports